/* src/app/shared/components/flow-chip/flow-chip.component.scss */
:host {
  display: inline-flex;
  max-width: 100%;
  min-width: 0;
}
.flow-chip {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
}
.flow-chip .chip-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 0;
}
.flow-chip .chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flow-chip .icon {
  height: 12px;
  width: 12px;
  flex-shrink: 0;
}
.flow-chip .close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 0 8px 8px 0;
  flex-shrink: 0;
}
.flow-chip .divider {
  width: 1px;
  height: 40px;
}
.flow-chip.size-small {
  height: 24px;
  gap: 0;
  border-radius: 8px;
}
.flow-chip.size-small .chip-body {
  gap: 4px;
  padding: 2px 8px 2px 4px;
  border-radius: 8px 0 0 8px;
}
.flow-chip.size-small .close-button {
  height: 24px;
  width: 24px;
  padding: 0;
}
.flow-chip.size-small .close-button .icon {
  height: 8px;
  width: 8px;
}
.flow-chip.size-small .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
}
.flow-chip.size-small .chip-body .icon {
  height: 10px;
  width: 10px;
}
.flow-chip.size-large {
  height: 32px;
  gap: 0;
  border-radius: 8px;
}
.flow-chip.size-large .chip-body {
  gap: 8px;
  padding: 4px 8px;
  border-radius: 8px 0 0 8px;
}
.flow-chip.size-large .close-button {
  height: 32px;
  width: 32px;
  padding: 0;
}
.flow-chip.size-large .close-button .icon {
  height: 10px;
  width: 10px;
}
.flow-chip.size-large .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
}
.flow-chip.color-neutral.type-solid {
  background-color: #e4e4e7;
}
.flow-chip.color-neutral.type-solid .body-3-medium,
.flow-chip.color-neutral.type-solid .body-3-semibold {
  color: #18181b;
}
.flow-chip.color-neutral.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-chip.color-neutral.type-solid:not(.disabled) .chip-body:hover {
  background-color: #d4d4d8;
}
.flow-chip.color-neutral.type-solid:not(.disabled) .close-button:hover {
  background-color: #d4d4d8;
}
.flow-chip.color-neutral.type-subtle {
  background-color: #f4f4f5;
}
.flow-chip.color-neutral.type-subtle .body-3-medium,
.flow-chip.color-neutral.type-subtle .body-3-semibold {
  color: #18181b;
}
.flow-chip.color-neutral.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(36%);
}
.flow-chip.color-neutral.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #e4e4e7;
}
.flow-chip.color-neutral.type-subtle:not(.disabled) .close-button:hover {
  background-color: #e4e4e7;
}
.flow-chip.color-neutral .divider {
  background-color: #f4f4f5;
}
.flow-chip.color-info1.type-solid {
  background-color: #4568d0;
}
.flow-chip.color-info1.type-solid .body-3-medium,
.flow-chip.color-info1.type-solid .body-3-semibold {
  color: #ffffff;
}
.flow-chip.color-info1.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-chip.color-info1.type-solid:not(.disabled) .chip-body:hover {
  background-color: #5580dc;
}
.flow-chip.color-info1.type-solid:not(.disabled) .close-button:hover {
  background-color: #5580dc;
}
.flow-chip.color-info1.type-subtle {
  background-color: #e0e9f9;
}
.flow-chip.color-info1.type-subtle .body-3-medium,
.flow-chip.color-info1.type-subtle .body-3-semibold {
  color: #3753be;
}
.flow-chip.color-info1.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(81%) saturate(2106%) hue-rotate(218deg) brightness(106%) contrast(101%);
}
.flow-chip.color-info1.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #c8d9f5;
}
.flow-chip.color-info1.type-subtle:not(.disabled) .close-button:hover {
  background-color: #c8d9f5;
}
.flow-chip.color-info1 .divider {
  background-color: #e0e9f9;
}
.flow-chip.color-info2.type-solid {
  background-color: #9333ea;
}
.flow-chip.color-info2.type-solid .body-3-medium,
.flow-chip.color-info2.type-solid .body-3-semibold {
  color: #ffffff;
}
.flow-chip.color-info2.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-chip.color-info2.type-solid:not(.disabled) .chip-body:hover {
  background-color: #a855f7;
}
.flow-chip.color-info2.type-solid:not(.disabled) .close-button:hover {
  background-color: #a855f7;
}
.flow-chip.color-info2.type-subtle {
  background-color: #f3e8ff;
}
.flow-chip.color-info2.type-subtle .body-3-medium,
.flow-chip.color-info2.type-subtle .body-3-semibold {
  color: #6b21a8;
}
.flow-chip.color-info2.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(14%) sepia(64%) saturate(4151%) hue-rotate(267deg) brightness(100%) contrast(96%);
}
.flow-chip.color-info2.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #e9d5ff;
}
.flow-chip.color-info2.type-subtle:not(.disabled) .close-button:hover {
  background-color: #e9d5ff;
}
.flow-chip.color-info2 .divider {
  background-color: #f3e8ff;
}
.flow-chip.color-success.type-solid {
  background-color: #15803d;
}
.flow-chip.color-success.type-solid .body-3-medium,
.flow-chip.color-success.type-solid .body-3-semibold {
  color: #ffffff;
}
.flow-chip.color-success.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-chip.color-success.type-solid:not(.disabled) .chip-body:hover {
  background-color: #16a34a;
}
.flow-chip.color-success.type-solid:not(.disabled) .close-button:hover {
  background-color: #16a34a;
}
.flow-chip.color-success.type-subtle {
  background-color: #dcfce7;
}
.flow-chip.color-success.type-subtle .body-3-medium,
.flow-chip.color-success.type-subtle .body-3-semibold {
  color: #166534;
}
.flow-chip.color-success.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(47%) saturate(719%) hue-rotate(90deg) brightness(100%) contrast(91%);
}
.flow-chip.color-success.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #bbf7d0;
}
.flow-chip.color-success.type-subtle:not(.disabled) .close-button:hover {
  background-color: #bbf7d0;
}
.flow-chip.color-success .divider {
  background-color: #dcfce7;
}
.flow-chip.color-warning1.type-solid {
  background-color: #facc15;
}
.flow-chip.color-warning1.type-solid .body-3-medium,
.flow-chip.color-warning1.type-solid .body-3-semibold {
  color: #18181b;
}
.flow-chip.color-warning1.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-chip.color-warning1.type-solid:not(.disabled) .chip-body:hover {
  background-color: #fde047;
}
.flow-chip.color-warning1.type-solid:not(.disabled) .close-button:hover {
  background-color: #fde047;
}
.flow-chip.color-warning1.type-subtle {
  background-color: #fef08a;
}
.flow-chip.color-warning1.type-subtle .body-3-medium,
.flow-chip.color-warning1.type-subtle .body-3-semibold {
  color: #854d0e;
}
.flow-chip.color-warning1.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(29%) sepia(88%) saturate(453%) hue-rotate(351deg) brightness(94%) contrast(99%);
}
.flow-chip.color-warning1.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #fde047;
}
.flow-chip.color-warning1.type-subtle:not(.disabled) .close-button:hover {
  background-color: #fde047;
}
.flow-chip.color-warning1 .divider {
  background-color: #fef08a;
}
.flow-chip.color-warning2.type-solid {
  background-color: #fb923c;
}
.flow-chip.color-warning2.type-solid .body-3-medium,
.flow-chip.color-warning2.type-solid .body-3-semibold {
  color: #18181b;
}
.flow-chip.color-warning2.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-chip.color-warning2.type-solid:not(.disabled) .chip-body:hover {
  background-color: #fdba74;
}
.flow-chip.color-warning2.type-solid:not(.disabled) .close-button:hover {
  background-color: #fdba74;
}
.flow-chip.color-warning2.type-subtle {
  background-color: #ffedd5;
}
.flow-chip.color-warning2.type-subtle .body-3-medium,
.flow-chip.color-warning2.type-subtle .body-3-semibold {
  color: #9a3412;
}
.flow-chip.color-warning2.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(42%) saturate(2304%) hue-rotate(348deg) brightness(86%) contrast(99%);
}
.flow-chip.color-warning2.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #fed7aa;
}
.flow-chip.color-warning2.type-subtle:not(.disabled) .close-button:hover {
  background-color: #fed7aa;
}
.flow-chip.color-warning2 .divider {
  background-color: #ffedd5;
}
.flow-chip.color-destructive.type-solid {
  background-color: #dc2626;
}
.flow-chip.color-destructive.type-solid .body-3-medium,
.flow-chip.color-destructive.type-solid .body-3-semibold {
  color: #ffffff;
}
.flow-chip.color-destructive.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-chip.color-destructive.type-solid:not(.disabled) .chip-body:hover {
  background-color: #ef4444;
}
.flow-chip.color-destructive.type-solid:not(.disabled) .close-button:hover {
  background-color: #ef4444;
}
.flow-chip.color-destructive.type-subtle {
  background-color: #fee2e2;
}
.flow-chip.color-destructive.type-subtle .body-3-medium,
.flow-chip.color-destructive.type-subtle .body-3-semibold {
  color: #b91c1c;
}
.flow-chip.color-destructive.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(31%) saturate(6219%) hue-rotate(345deg) brightness(89%) contrast(99%);
}
.flow-chip.color-destructive.type-subtle:not(.disabled) .chip-body:hover {
  background-color: #fecaca;
}
.flow-chip.color-destructive.type-subtle:not(.disabled) .close-button:hover {
  background-color: #fecaca;
}
.flow-chip.color-destructive .divider {
  background-color: #fee2e2;
}
.flow-chip.disabled.type-solid,
.flow-chip.disabled.type-subtle {
  background-color: #f4f4f5;
}
.flow-chip.disabled.type-solid .body-3-semibold,
.flow-chip.disabled.type-subtle .body-3-semibold {
  color: #a1a1aa;
}
.flow-chip.disabled.type-solid .icon,
.flow-chip.disabled.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(65%);
}
.flow-chip.disabled .close-button {
  cursor: not-allowed;
}
/*# sourceMappingURL=flow-chip.component.css.map */
